import { ITaskAcceptRequestBody, ITaskItemRow } from "../../../models/Task";

export const actionTypes = {
  FETCH_CSV_TASKS_REQUEST: "FETCH_CSV_TASKS_REQUEST",
  FETCH_CSV_TASKS_SUCCESS: "FETCH_CSV_TASKS_SUCCESS",
  FETCH_CSV_TASKS_FAILURE: "FETCH_CSV_TASKS_FAILURE",

  FETCH_TASKS_REQUEST: "FETCH_TASKS_REQUEST",
  FETCH_TASKS_SUCCESS: "FETCH_TASKS_SUCCESS",
  FETCH_TASKS_FAILURE: "FETCH_TASKS_FAILURE",

  FETCH_PAGINATED_TASKS_REQUEST: "FETCH_PAGINATED_TASKS_REQUEST",
  FETCH_PAGINATED_TASKS_SUCCESS: "FETCH_PAGINATED_TASKS_SUCCESS",
  FETCH_PAGINATED_TASKS_FAILURE: "FETCH_PAGINATED_TASKS_FAILURE",

  SELECT_TASK: "SELECT_TASK",
  FETCH_TASK_DETAIL: "FETCH_TASK_DETAIL",
  FETCH_TASK_DETAIL_SUCCESS: "FETCH_TASK_DETAIL_SUCCESS",
  FETCH_TASK_DETAIL_FAILURE: "FETCH_TASK_DETAIL_FAILURE",
  APPROVE_TASK_REQUEST: "APPROVE_TASK_REQUEST",
  APPROVE_TASK_REQUEST_SUCCESS: "APPROVE_TASK_REQUEST_SUCCESS",
  APPROVE_TASK_REQUEST_FAILURE: "APPROVE_TASK_REQUEST_FAILURE",
  APPROVE_COMMENT_TASK_REQUEST: "APPROVE_COMMENT_TASK_REQUEST",
  APPROVE_COMMENT_TASK_REQUEST_SUCCESS: "APPROVE_COMMENT_TASK_REQUEST_SUCCESS",
  APPROVE_COMMENT_TASK_REQUEST_FAILURE: "APPROVE_COMMENT_TASK_REQUEST_FAILURE",
  REJECT_TASK_REQUEST: "REJECT_TASK_REQUEST",
  REJECT_TASK_REQUEST_SUCCESS: "REJECT_TASK_REQUEST_SUCCESS",
  REJECT_TASK_REQUEST_FAILURE: "REJECT_TASK_REQUEST_FAILURE",
  REJECT_COMMENT_TASK_REQUEST: "REJECT_COMMENT_TASK_REQUEST",
  REJECT_COMMENT_TASK_REQUEST_SUCCESS: "REJECT_COMMENT_TASK_REQUEST_SUCCESS",
  REJECT_COMMENT_TASK_REQUEST_FAILURE: "REJECT_COMMENT_TASK_REQUEST_FAILURE",
  TAKE_CHARGE_TASK_REQUEST: "TAKE_CHARGE_TASK_REQUEST",
  TAKE_CHARGE_TASK_REQUEST_SUCCESS: "TAKE_CHARGE_TASK_REQUEST_SUCCESS",
  TAKE_CHARGE_TASK_REQUEST_FAILURE: "TAKE_CHARGE_TASK_REQUEST_FAILURE",
  CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST:
    "CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST",
  CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_SUCCESS:
    "CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_SUCCESS",
  CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_FAILURE:
    "CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_FAILURE",
  SET_SELECTED_AGGREGATE_TASK: "SET_SELECTED_AGGREGATE_TASK",
  RESET_TASK_DETAIL: "RESET_TASK_DETAIL",

  UPDATE_TASK_TMP_ATTRIBUTES: "UPDATE_TASK_TMP_ATTRIBUTES",
};

export const fetchCSVTask = (payload: any) => {
  return {
    type: actionTypes.FETCH_CSV_TASKS_REQUEST,
    payload,
  };
};

export const fetchCSVTaskFailure = (error: any) => {
  return {
    type: actionTypes.FETCH_CSV_TASKS_FAILURE,
    error,
  };
};

export const fetchCSVTaskSuccess = (payload: any[]) => {
  return {
    type: actionTypes.FETCH_CSV_TASKS_SUCCESS,
    payload,
  };
};

export const fetchTask = () => {
  return {
    type: actionTypes.FETCH_TASKS_REQUEST,
  };
};

export const fetchTaskFailure = (error: any) => {
  return {
    type: actionTypes.FETCH_TASKS_FAILURE,
    error,
  };
};

export const fetchTaskSuccess = (payload: ITaskItemRow[]) => {
  return {
    type: actionTypes.FETCH_TASKS_SUCCESS,
    payload,
  };
};
export const fetchPaginatedTask = (payload: any) => {
  return {
    type: actionTypes.FETCH_PAGINATED_TASKS_REQUEST,
    payload,
  };
};

export const fetchPaginatedTaskFailure = (error: any) => {
  return {
    type: actionTypes.FETCH_PAGINATED_TASKS_FAILURE,
    error,
  };
};

export const fetchPaginatedTaskSuccess = (payload: ITaskItemRow[]) => {
  return {
    type: actionTypes.FETCH_PAGINATED_TASKS_SUCCESS,
    payload,
  };
};

export const selectTaskRequest = (payload: any) => ({
  type: actionTypes.SELECT_TASK,
  payload,
});

export const fetchTaskDetail = (body: {
  codeOperation: string;
  userId: string;
  application: string;
}) => {
  return {
    type: actionTypes.FETCH_TASK_DETAIL,
    body,
  };
};

export const fetchTaskDetailSuccess = (payload: any) => {
  return {
    type: actionTypes.FETCH_TASK_DETAIL_SUCCESS,
    payload,
  };
};

export const fetchTaskDetailFailure = (error: any) => {
  return {
    type: actionTypes.FETCH_TASK_DETAIL_FAILURE,
    error,
  };
};

export const resetTaskDetail = () => {
  return {
    type: actionTypes.RESET_TASK_DETAIL,
  };
};

export const approveTaskRequest = (body: ITaskAcceptRequestBody[]) => {
  return {
    type: actionTypes.APPROVE_TASK_REQUEST,
    body,
  };
};

export const approveTaskRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.APPROVE_TASK_REQUEST_SUCCESS,
    payload,
  };
};

export const approveTaskRequestFailure = (error: any) => {
  return {
    type: actionTypes.APPROVE_TASK_REQUEST_FAILURE,
    error,
  };
};

export const approveCommentTaskRequest = (req: {
  body: ITaskAcceptRequestBody[];
  comment: string;
}) => {
  return {
    type: actionTypes.APPROVE_COMMENT_TASK_REQUEST,
    req,
  };
};

export const approveCommentTaskRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.APPROVE_COMMENT_TASK_REQUEST_SUCCESS,
    payload,
  };
};

export const approveCommentTaskRequestFailure = (error: any) => {
  return {
    type: actionTypes.APPROVE_COMMENT_TASK_REQUEST_FAILURE,
    error,
  };
};

export const rejectTaskRequest = (body: string[]) => {
  return {
    type: actionTypes.REJECT_TASK_REQUEST,
    body,
  };
};

export const rejectTaskRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.REJECT_TASK_REQUEST_SUCCESS,
    payload,
  };
};

export const rejectTaskRequestFailure = (error: any) => {
  return {
    type: actionTypes.REJECT_TASK_REQUEST_FAILURE,
    error,
  };
};

export const rejectCommentTaskRequest = (req: {
  body: string[];
  comment: string;
}) => {
  return {
    type: actionTypes.REJECT_COMMENT_TASK_REQUEST,
    req,
  };
};

export const rejectCommentTaskRequestSuccess = (payload: any) => {
  return {
    type: actionTypes.REJECT_COMMENT_TASK_REQUEST_SUCCESS,
    payload,
  };
};

export const rejectCommentTaskRequestFailure = (error: any) => {
  return {
    type: actionTypes.REJECT_COMMENT_TASK_REQUEST_FAILURE,
    error,
  };
};

export const takeChargeRequest = (payload: any) => {
  return { type: actionTypes.TAKE_CHARGE_TASK_REQUEST, payload };
};

export const takeChargeRequestSucess = (payload: any) => {
  return { type: actionTypes.TAKE_CHARGE_TASK_REQUEST_SUCCESS, payload };
};

export const takeChargeRequestFailure = (error: Error) => {
  return { type: actionTypes.TAKE_CHARGE_TASK_REQUEST_FAILURE, error };
};

export const cancelTakeChargeRequest = (payload: any) => {
  return {
    type: actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST,
    payload,
  };
};

export const cancelTakeChargeRequestSucess = (payload: any) => {
  return {
    type: actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_SUCCESS,
    payload,
  };
};

export const cancelTakeChargeRequestFailure = (error: Error) => {
  return {
    type: actionTypes.CANCEL_TAKE_CHARGE_TASK_REQUEST_TASK_REQUEST_FAILURE,
    error,
  };
};

export const updateTaskTmpAttributes = (payload: any) => {
  return {
    type: actionTypes.UPDATE_TASK_TMP_ATTRIBUTES,
    payload,
  };
};
